import React from 'react';
import PropTypes from 'prop-types';

import InfoSelectField from 'ntnu-react/material/InfoSelectField';
import InfoTextField from 'ntnu-react/material/InfoTextField';
import MenuItem from 'material-ui/MenuItem';

import info from '../constants/infotexts.json';
import fasttrack from '../constants/fasttrack.json';

class FastTrackTab extends React.Component {
    shouldComponentUpdate(nextProps) {
        const old = this.props.data;
        const next = nextProps.data;

        return old.FastTrack !== next.FastTrack
        || old.F_Reason !== next.F_Reason;
    }

    handleSelectChange = (field) => {
        return (e, index, value) => {
            this.props.fieldChange(field, value, true);
        };
    }

    handleTextChange = (field, recalc) => {
        return (e) => {
            this.props.fieldChange(field, e.target.value, recalc);
        };
    }

    render() {
        const { data } = this.props;
        return (
            <section>
                <p>Endringen har kort gjennomføringsvarighet på maksimalt 2-3 mnd, og gjerne med hyppige løpende leveranser på 1-2 uker.</p>
                <InfoSelectField
                    floatingLabelText="Anbefales som Fast-track?"
                    infoText={info.fasttrack.FastTrack}
                    value={data.FastTrack}
                    onChange={this.handleSelectChange('FastTrack')}
                    disabled={this.props.disabled}
                >
                    {fasttrack.map((item) => (
                        <MenuItem
                            key={item.key}
                            value={item.key}
                            primaryText={item.text}
                            insetChildren={true}
                            checked={data.FastTrack === item.key}
                        />
                    ))}
                </InfoSelectField>

                <InfoTextField
                    floatingLabelText="Kort begrunnelse hvis Fast-track"
                    infoText={info.fasttrack.Reason}
                    fullWidth={true}
                    value={data.F_Reason}
                    onChange={this.handleTextChange('F_Reason')}
                    multiLine={true}
                    rows={4}
                    disabled={data.FastTrack === "0" || this.props.disabled}
                />
            </section>
        );
    }
}

FastTrackTab.propTypes = {
    data: PropTypes.object.isRequired,
    fieldChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    disabled: PropTypes.bool,
};

export default FastTrackTab;



// WEBPACK FOOTER //
// ./src/components/FastTrackTab.js